"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var es_1 = require("./es");
Object.defineProperty(exports, "es", { enumerable: true, get: function () { return es_1.default; } });
var en_1 = require("./en");
Object.defineProperty(exports, "en", { enumerable: true, get: function () { return en_1.default; } });
var cn_1 = require("./cn");
Object.defineProperty(exports, "cn", { enumerable: true, get: function () { return cn_1.default; } });
//# sourceMappingURL=index.js.map